//library
import React from "react";
import { Box, Dialog, Typography } from "@mui/material";

//code
import useStyles from "../../styles/styles";
import TraxxButton from "../../../TraxxButton";

const ReferralDialog = ({
	enqueueSnackbar,
	openReferralDialog,
	sendReferralDialogBox,
	applicantData,
}) => {
	const classes = useStyles();

	const encodeURIAll = (text) => {
		return encodeURIComponent(text).replace(/[!'()~*]/g, (c) => {
			return "%" + c.charCodeAt(0).toString(16);
		});
	};
	const referralLink =
		"https://apply.traxx.asia/?referral=" +
		applicantData.application_id +
		"&" +
		"compName=" +
		encodeURIAll(applicantData.companyName);

	const copyLink = () => {
		navigator.clipboard.writeText(referralLink);
		enqueueSnackbar("Referral Link Copied!", {
			variant: "success",
			autoHideDuration: 3000,
		});
	};
	return (
		<Dialog
			maxWidth={"md"}
			open={openReferralDialog}
			onClose={sendReferralDialogBox}
		>
			<Box className={classes.manualOverrideBox}>
				<Typography variant="h6" className={classes.dialogHeader}>
					Referral Link
				</Typography>
				<hr />
				<Typography variant="h6" className={classes.dialogHeader}>
					{referralLink} <TraxxButton onSubmit={copyLink}>Copy</TraxxButton>
				</Typography>

				<hr />
			</Box>
		</Dialog>
	);
};
export default ReferralDialog;
